/**
 * Generated by @openapi-codegen
 *
 * @version 1.0
 */
import type * as Fetcher from './controlPlaneFetcher';
import { controlPlaneFetch, ControlPlaneFetcherExtraProps } from './controlPlaneFetcher';
import type * as Schemas from './controlPlaneSchemas';
import type * as Responses from './controlPlaneResponses';

export type GetAuthorizationCodeQueryParams = {
  clientID: string;
  responseType: Schemas.OAuthResponseType;
  redirectUri?: string;
  scopes?: Schemas.OAuthScope[];
  state?: string;
};

export type GetAuthorizationCodeError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
  | {
      status: 409;
      payload: Responses.SimpleError;
    }
>;

export type GetAuthorizationCodeVariables = {
  queryParams: GetAuthorizationCodeQueryParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Creates, stores and returns an authorization code to be used by a third party app. Supporting use of GET is required by OAuth2 spec
 */
export const getAuthorizationCode = (variables: GetAuthorizationCodeVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.AuthorizationCodeResponse,
    GetAuthorizationCodeError,
    undefined,
    {},
    GetAuthorizationCodeQueryParams,
    {}
  >({ url: '/oauth/authorize', method: 'get', ...variables, signal });

export type GrantAuthorizationCodeError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
  | {
      status: 409;
      payload: Responses.SimpleError;
    }
>;

export type GrantAuthorizationCodeVariables = {
  body: Schemas.AuthorizationCodeRequest;
} & ControlPlaneFetcherExtraProps;

/**
 * Creates, stores and returns an authorization code to be used by a third party app
 */
export const grantAuthorizationCode = (variables: GrantAuthorizationCodeVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.AuthorizationCodeResponse,
    GrantAuthorizationCodeError,
    Schemas.AuthorizationCodeRequest,
    {},
    {},
    {}
  >({ url: '/oauth/authorize', method: 'post', ...variables, signal });

export type GetUserError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type GetUserVariables = ControlPlaneFetcherExtraProps;

/**
 * Return details of the user making the request
 */
export const getUser = (variables: GetUserVariables, signal?: AbortSignal) =>
  controlPlaneFetch<Schemas.UserWithID, GetUserError, undefined, {}, {}, {}>({
    url: '/user',
    method: 'get',
    ...variables,
    signal
  });

export type UpdateUserError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type UpdateUserVariables = {
  body: Schemas.User;
} & ControlPlaneFetcherExtraProps;

/**
 * Update user info
 */
export const updateUser = (variables: UpdateUserVariables, signal?: AbortSignal) =>
  controlPlaneFetch<Schemas.UserWithID, UpdateUserError, Schemas.User, {}, {}, {}>({
    url: '/user',
    method: 'put',
    ...variables,
    signal
  });

export type DeleteUserError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type DeleteUserVariables = ControlPlaneFetcherExtraProps;

/**
 * Delete the user making the request
 */
export const deleteUser = (variables: DeleteUserVariables, signal?: AbortSignal) =>
  controlPlaneFetch<undefined, DeleteUserError, undefined, {}, {}, {}>({
    url: '/user',
    method: 'delete',
    ...variables,
    signal
  });

export type GetUserAPIKeysError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type GetUserAPIKeysResponse = {
  keys: {
    name: string;
    createdAt: Schemas.DateTime;
  }[];
};

export type GetUserAPIKeysVariables = ControlPlaneFetcherExtraProps;

/**
 * Retrieve a list of existing user API keys
 */
export const getUserAPIKeys = (variables: GetUserAPIKeysVariables, signal?: AbortSignal) =>
  controlPlaneFetch<GetUserAPIKeysResponse, GetUserAPIKeysError, undefined, {}, {}, {}>({
    url: '/user/keys',
    method: 'get',
    ...variables,
    signal
  });

export type CreateUserAPIKeyPathParams = {
  /**
   * API Key name
   */
  keyName: Schemas.APIKeyName;
};

export type CreateUserAPIKeyError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type CreateUserAPIKeyResponse = {
  name: string;
  key: string;
  createdAt: Schemas.DateTime;
};

export type CreateUserAPIKeyVariables = {
  pathParams: CreateUserAPIKeyPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Create and return new API key
 */
export const createUserAPIKey = (variables: CreateUserAPIKeyVariables, signal?: AbortSignal) =>
  controlPlaneFetch<CreateUserAPIKeyResponse, CreateUserAPIKeyError, undefined, {}, {}, CreateUserAPIKeyPathParams>({
    url: '/user/keys/{keyName}',
    method: 'post',
    ...variables,
    signal
  });

export type DeleteUserAPIKeyPathParams = {
  /**
   * API Key name
   */
  keyName: Schemas.APIKeyName;
};

export type DeleteUserAPIKeyError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type DeleteUserAPIKeyVariables = {
  pathParams: DeleteUserAPIKeyPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Delete an existing API key
 */
export const deleteUserAPIKey = (variables: DeleteUserAPIKeyVariables, signal?: AbortSignal) =>
  controlPlaneFetch<undefined, DeleteUserAPIKeyError, undefined, {}, {}, DeleteUserAPIKeyPathParams>({
    url: '/user/keys/{keyName}',
    method: 'delete',
    ...variables,
    signal
  });

export type GetUserOAuthClientsError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type GetUserOAuthClientsResponse = {
  clients?: Schemas.OAuthClientPublicDetails[];
};

export type GetUserOAuthClientsVariables = ControlPlaneFetcherExtraProps;

/**
 * Retrieve the list of OAuth Clients that a user has authorized
 */
export const getUserOAuthClients = (variables: GetUserOAuthClientsVariables, signal?: AbortSignal) =>
  controlPlaneFetch<GetUserOAuthClientsResponse, GetUserOAuthClientsError, undefined, {}, {}, {}>({
    url: '/user/oauth/clients',
    method: 'get',
    ...variables,
    signal
  });

export type DeleteUserOAuthClientPathParams = {
  clientId: Schemas.OAuthClientID;
};

export type DeleteUserOAuthClientError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type DeleteUserOAuthClientVariables = {
  pathParams: DeleteUserOAuthClientPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Delete the oauth client for the user and revoke all access
 */
export const deleteUserOAuthClient = (variables: DeleteUserOAuthClientVariables, signal?: AbortSignal) =>
  controlPlaneFetch<undefined, DeleteUserOAuthClientError, undefined, {}, {}, DeleteUserOAuthClientPathParams>({
    url: '/user/oauth/clients/{clientId}',
    method: 'delete',
    ...variables,
    signal
  });

export type GetUserOAuthAccessTokensError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type GetUserOAuthAccessTokensResponse = {
  accessTokens: Schemas.OAuthAccessToken[];
};

export type GetUserOAuthAccessTokensVariables = ControlPlaneFetcherExtraProps;

/**
 * Retrieve the list of valid OAuth Access Tokens on the current user's account
 */
export const getUserOAuthAccessTokens = (variables: GetUserOAuthAccessTokensVariables, signal?: AbortSignal) =>
  controlPlaneFetch<GetUserOAuthAccessTokensResponse, GetUserOAuthAccessTokensError, undefined, {}, {}, {}>({
    url: '/user/oauth/tokens',
    method: 'get',
    ...variables,
    signal
  });

export type DeleteOAuthAccessTokenPathParams = {
  token: Schemas.AccessToken;
};

export type DeleteOAuthAccessTokenError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
  | {
      status: 409;
      payload: Responses.SimpleError;
    }
>;

export type DeleteOAuthAccessTokenVariables = {
  pathParams: DeleteOAuthAccessTokenPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Expires the access token for a third party app
 */
export const deleteOAuthAccessToken = (variables: DeleteOAuthAccessTokenVariables, signal?: AbortSignal) =>
  controlPlaneFetch<undefined, DeleteOAuthAccessTokenError, undefined, {}, {}, DeleteOAuthAccessTokenPathParams>({
    url: '/user/oauth/tokens/{token}',
    method: 'delete',
    ...variables,
    signal
  });

export type UpdateOAuthAccessTokenPathParams = {
  token: Schemas.AccessToken;
};

export type UpdateOAuthAccessTokenError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
  | {
      status: 409;
      payload: Responses.SimpleError;
    }
>;

export type UpdateOAuthAccessTokenRequestBody = {
  /**
   * expiration time of the token as a unix timestamp
   */
  expires: number;
};

export type UpdateOAuthAccessTokenVariables = {
  body: UpdateOAuthAccessTokenRequestBody;
  pathParams: UpdateOAuthAccessTokenPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Updates partially the access token for a third party app
 */
export const updateOAuthAccessToken = (variables: UpdateOAuthAccessTokenVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.OAuthAccessToken,
    UpdateOAuthAccessTokenError,
    UpdateOAuthAccessTokenRequestBody,
    {},
    {},
    UpdateOAuthAccessTokenPathParams
  >({ url: '/user/oauth/tokens/{token}', method: 'patch', ...variables, signal });

export type GetWorkspacesListError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type GetWorkspacesListResponse = {
  workspaces: {
    id: Schemas.WorkspaceID;
    name: string;
    slug: string;
    role: Schemas.Role;
    plan: Schemas.WorkspacePlan;
  }[];
};

export type GetWorkspacesListVariables = ControlPlaneFetcherExtraProps;

/**
 * Retrieve the list of workspaces the user belongs to
 */
export const getWorkspacesList = (variables: GetWorkspacesListVariables, signal?: AbortSignal) =>
  controlPlaneFetch<GetWorkspacesListResponse, GetWorkspacesListError, undefined, {}, {}, {}>({
    url: '/workspaces',
    method: 'get',
    ...variables,
    signal
  });

export type CreateWorkspaceError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type CreateWorkspaceVariables = {
  body: Schemas.WorkspaceMeta;
} & ControlPlaneFetcherExtraProps;

/**
 * Creates a new workspace with the user requesting it as its single owner.
 */
export const createWorkspace = (variables: CreateWorkspaceVariables, signal?: AbortSignal) =>
  controlPlaneFetch<Schemas.Workspace, CreateWorkspaceError, Schemas.WorkspaceMeta, {}, {}, {}>({
    url: '/workspaces',
    method: 'post',
    ...variables,
    signal
  });

export type GetWorkspacePathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
};

export type GetWorkspaceError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 403;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type GetWorkspaceVariables = {
  pathParams: GetWorkspacePathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Retrieve workspace info from a workspace ID
 */
export const getWorkspace = (variables: GetWorkspaceVariables, signal?: AbortSignal) =>
  controlPlaneFetch<Schemas.Workspace, GetWorkspaceError, undefined, {}, {}, GetWorkspacePathParams>({
    url: '/workspaces/{workspaceId}',
    method: 'get',
    ...variables,
    signal
  });

export type UpdateWorkspacePathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
};

export type UpdateWorkspaceError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 403;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type UpdateWorkspaceVariables = {
  body: Schemas.WorkspaceMeta;
  pathParams: UpdateWorkspacePathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Update workspace info
 */
export const updateWorkspace = (variables: UpdateWorkspaceVariables, signal?: AbortSignal) =>
  controlPlaneFetch<Schemas.Workspace, UpdateWorkspaceError, Schemas.WorkspaceMeta, {}, {}, UpdateWorkspacePathParams>({
    url: '/workspaces/{workspaceId}',
    method: 'put',
    ...variables,
    signal
  });

export type DeleteWorkspacePathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
};

export type DeleteWorkspaceError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 403;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type DeleteWorkspaceVariables = {
  pathParams: DeleteWorkspacePathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Delete the workspace with the provided ID
 */
export const deleteWorkspace = (variables: DeleteWorkspaceVariables, signal?: AbortSignal) =>
  controlPlaneFetch<undefined, DeleteWorkspaceError, undefined, {}, {}, DeleteWorkspacePathParams>({
    url: '/workspaces/{workspaceId}',
    method: 'delete',
    ...variables,
    signal
  });

export type GetWorkspaceMembersListPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
};

export type GetWorkspaceMembersListError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 403;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type GetWorkspaceMembersListVariables = {
  pathParams: GetWorkspaceMembersListPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Retrieve the list of members of the given workspace
 */
export const getWorkspaceMembersList = (variables: GetWorkspaceMembersListVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.WorkspaceMembers,
    GetWorkspaceMembersListError,
    undefined,
    {},
    {},
    GetWorkspaceMembersListPathParams
  >({ url: '/workspaces/{workspaceId}/members', method: 'get', ...variables, signal });

export type UpdateWorkspaceMemberRolePathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * UserID
   */
  userId: Schemas.UserID;
};

export type UpdateWorkspaceMemberRoleError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 403;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type UpdateWorkspaceMemberRoleRequestBody = {
  role: Schemas.Role;
};

export type UpdateWorkspaceMemberRoleVariables = {
  body: UpdateWorkspaceMemberRoleRequestBody;
  pathParams: UpdateWorkspaceMemberRolePathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Update a workspace member role. Workspaces must always have at least one owner, so this operation will fail if trying to remove owner role from the last owner in the workspace.
 */
export const updateWorkspaceMemberRole = (variables: UpdateWorkspaceMemberRoleVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    undefined,
    UpdateWorkspaceMemberRoleError,
    UpdateWorkspaceMemberRoleRequestBody,
    {},
    {},
    UpdateWorkspaceMemberRolePathParams
  >({ url: '/workspaces/{workspaceId}/members/{userId}', method: 'put', ...variables, signal });

export type RemoveWorkspaceMemberPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * UserID
   */
  userId: Schemas.UserID;
};

export type RemoveWorkspaceMemberError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 403;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type RemoveWorkspaceMemberVariables = {
  pathParams: RemoveWorkspaceMemberPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Remove the member from the workspace
 */
export const removeWorkspaceMember = (variables: RemoveWorkspaceMemberVariables, signal?: AbortSignal) =>
  controlPlaneFetch<undefined, RemoveWorkspaceMemberError, undefined, {}, {}, RemoveWorkspaceMemberPathParams>({
    url: '/workspaces/{workspaceId}/members/{userId}',
    method: 'delete',
    ...variables,
    signal
  });

export type InviteWorkspaceMemberPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
};

export type InviteWorkspaceMemberError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 403;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
  | {
      status: 409;
      payload: Responses.SimpleError;
    }
>;

export type InviteWorkspaceMemberRequestBody = {
  /**
   * @format email
   */
  email: string;
  role: Schemas.Role;
};

export type InviteWorkspaceMemberVariables = {
  body: InviteWorkspaceMemberRequestBody;
  pathParams: InviteWorkspaceMemberPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Invite some user to join the workspace with the given role
 */
export const inviteWorkspaceMember = (variables: InviteWorkspaceMemberVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.WorkspaceInvite,
    InviteWorkspaceMemberError,
    InviteWorkspaceMemberRequestBody,
    {},
    {},
    InviteWorkspaceMemberPathParams
  >({ url: '/workspaces/{workspaceId}/invites', method: 'post', ...variables, signal });

export type UpdateWorkspaceMemberInvitePathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * Invite identifier
   */
  inviteId: Schemas.InviteID;
};

export type UpdateWorkspaceMemberInviteError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 403;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
  | {
      status: 422;
      payload: Responses.SimpleError;
    }
>;

export type UpdateWorkspaceMemberInviteRequestBody = {
  role: Schemas.Role;
};

export type UpdateWorkspaceMemberInviteVariables = {
  body: UpdateWorkspaceMemberInviteRequestBody;
  pathParams: UpdateWorkspaceMemberInvitePathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * This operation provides a way to update an existing invite. Updates are performed in-place; they do not change the invite link, the expiry time, nor do they re-notify the recipient of the invite.
 */
export const updateWorkspaceMemberInvite = (variables: UpdateWorkspaceMemberInviteVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.WorkspaceInvite,
    UpdateWorkspaceMemberInviteError,
    UpdateWorkspaceMemberInviteRequestBody,
    {},
    {},
    UpdateWorkspaceMemberInvitePathParams
  >({ url: '/workspaces/{workspaceId}/invites/{inviteId}', method: 'patch', ...variables, signal });

export type CancelWorkspaceMemberInvitePathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * Invite identifier
   */
  inviteId: Schemas.InviteID;
};

export type CancelWorkspaceMemberInviteError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 403;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type CancelWorkspaceMemberInviteVariables = {
  pathParams: CancelWorkspaceMemberInvitePathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * This operation provides a way to cancel invites by deleting them. Already accepted invites cannot be deleted.
 */
export const cancelWorkspaceMemberInvite = (variables: CancelWorkspaceMemberInviteVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    undefined,
    CancelWorkspaceMemberInviteError,
    undefined,
    {},
    {},
    CancelWorkspaceMemberInvitePathParams
  >({ url: '/workspaces/{workspaceId}/invites/{inviteId}', method: 'delete', ...variables, signal });

export type AcceptWorkspaceMemberInvitePathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * Invite Key (secret) for the invited user
   */
  inviteKey: Schemas.InviteKey;
};

export type AcceptWorkspaceMemberInviteError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 403;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type AcceptWorkspaceMemberInviteVariables = {
  pathParams: AcceptWorkspaceMemberInvitePathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Accept the invitation to join a workspace. If the operation succeeds the user will be a member of the workspace
 */
export const acceptWorkspaceMemberInvite = (variables: AcceptWorkspaceMemberInviteVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    undefined,
    AcceptWorkspaceMemberInviteError,
    undefined,
    {},
    {},
    AcceptWorkspaceMemberInvitePathParams
  >({ url: '/workspaces/{workspaceId}/invites/{inviteKey}/accept', method: 'post', ...variables, signal });

export type ResendWorkspaceMemberInvitePathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * Invite identifier
   */
  inviteId: Schemas.InviteID;
};

export type ResendWorkspaceMemberInviteError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 403;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type ResendWorkspaceMemberInviteVariables = {
  pathParams: ResendWorkspaceMemberInvitePathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * This operation provides a way to resend an Invite notification. Invite notifications can only be sent for Invites not yet accepted.
 */
export const resendWorkspaceMemberInvite = (variables: ResendWorkspaceMemberInviteVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    undefined,
    ResendWorkspaceMemberInviteError,
    undefined,
    {},
    {},
    ResendWorkspaceMemberInvitePathParams
  >({ url: '/workspaces/{workspaceId}/invites/{inviteId}/resend', method: 'post', ...variables, signal });

export type ListClustersPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
};

export type ListClustersQueryParams = {
  /**
   * Page size
   */
  page?: Schemas.PageSize;
  /**
   * Page token
   */
  token?: Schemas.PageToken;
};

export type ListClustersError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
>;

export type ListClustersVariables = {
  pathParams: ListClustersPathParams;
  queryParams?: ListClustersQueryParams;
} & ControlPlaneFetcherExtraProps;

/**
 * List all clusters available in your Workspace.
 */
export const listClusters = (variables: ListClustersVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.ListClustersResponse,
    ListClustersError,
    undefined,
    {},
    ListClustersQueryParams,
    ListClustersPathParams
  >({ url: '/workspaces/{workspaceId}/clusters', method: 'get', ...variables, signal });

export type CreateClusterPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
};

export type CreateClusterError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 422;
      payload: Responses.SimpleError;
    }
  | {
      status: 423;
      payload: Responses.SimpleError;
    }
>;

export type CreateClusterVariables = {
  body: Schemas.ClusterCreateDetails;
  pathParams: CreateClusterPathParams;
} & ControlPlaneFetcherExtraProps;

export const createCluster = (variables: CreateClusterVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.ClusterResponse,
    CreateClusterError,
    Schemas.ClusterCreateDetails,
    {},
    {},
    CreateClusterPathParams
  >({ url: '/workspaces/{workspaceId}/clusters', method: 'post', ...variables, signal });

export type GetClusterPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * Cluster ID
   */
  clusterId: Schemas.ClusterID;
};

export type GetClusterError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
>;

export type GetClusterVariables = {
  pathParams: GetClusterPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Retrieve metadata for given cluster ID
 */
export const getCluster = (variables: GetClusterVariables, signal?: AbortSignal) =>
  controlPlaneFetch<Schemas.ClusterMetadata, GetClusterError, undefined, {}, {}, GetClusterPathParams>({
    url: '/workspaces/{workspaceId}/clusters/{clusterId}',
    method: 'get',
    ...variables,
    signal
  });

export type UpdateClusterPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * Cluster ID
   */
  clusterId: Schemas.ClusterID;
};

export type UpdateClusterError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
>;

export type UpdateClusterVariables = {
  body: Schemas.ClusterUpdateDetails;
  pathParams: UpdateClusterPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Update cluster for given cluster ID
 */
export const updateCluster = (variables: UpdateClusterVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.ClusterMetadata,
    UpdateClusterError,
    Schemas.ClusterUpdateDetails,
    {},
    {},
    UpdateClusterPathParams
  >({ url: '/workspaces/{workspaceId}/clusters/{clusterId}', method: 'patch', ...variables, signal });

export type GetDatabaseListPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
};

export type GetDatabaseListError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
>;

export type GetDatabaseListVariables = {
  pathParams: GetDatabaseListPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * List all databases available in your Workspace.
 */
export const getDatabaseList = (variables: GetDatabaseListVariables, signal?: AbortSignal) =>
  controlPlaneFetch<Schemas.ListDatabasesResponse, GetDatabaseListError, undefined, {}, {}, GetDatabaseListPathParams>({
    url: '/workspaces/{workspaceId}/dbs',
    method: 'get',
    ...variables,
    signal
  });

export type CreateDatabasePathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * The Database Name
   */
  dbName: Schemas.DBName;
};

export type CreateDatabaseError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 422;
      payload: Responses.SimpleError;
    }
  | {
      status: 423;
      payload: Responses.SimpleError;
    }
>;

export type CreateDatabaseResponse = {
  /**
   * @minLength 1
   */
  databaseName: string;
  branchName?: string;
  status: Schemas.MigrationStatus;
};

export type CreateDatabaseRequestBody = {
  /**
   * @minLength 1
   */
  branchName?: string;
  /**
   * @minLength 1
   */
  region: string;
  /**
   * The dedicated cluster where branches from this database will be created. Defaults to 'shared-cluster'.
   *
   * @minLength 1
   * @x-internal true
   */
  defaultClusterID?: string;
  ui?: {
    color?: string;
  };
  metadata?: Schemas.BranchMetadata;
};

export type CreateDatabaseVariables = {
  body: CreateDatabaseRequestBody;
  pathParams: CreateDatabasePathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Create Database with identifier name
 */
export const createDatabase = (variables: CreateDatabaseVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    CreateDatabaseResponse,
    CreateDatabaseError,
    CreateDatabaseRequestBody,
    {},
    {},
    CreateDatabasePathParams
  >({ url: '/workspaces/{workspaceId}/dbs/{dbName}', method: 'put', ...variables, signal });

export type DeleteDatabasePathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * The Database Name
   */
  dbName: Schemas.DBName;
};

export type DeleteDatabaseError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type DeleteDatabaseResponse = {
  status: Schemas.MigrationStatus;
};

export type DeleteDatabaseVariables = {
  pathParams: DeleteDatabasePathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Delete a database and all of its branches and tables permanently.
 */
export const deleteDatabase = (variables: DeleteDatabaseVariables, signal?: AbortSignal) =>
  controlPlaneFetch<DeleteDatabaseResponse, DeleteDatabaseError, undefined, {}, {}, DeleteDatabasePathParams>({
    url: '/workspaces/{workspaceId}/dbs/{dbName}',
    method: 'delete',
    ...variables,
    signal
  });

export type GetDatabaseMetadataPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * The Database Name
   */
  dbName: Schemas.DBName;
};

export type GetDatabaseMetadataError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type GetDatabaseMetadataVariables = {
  pathParams: GetDatabaseMetadataPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Retrieve metadata of the given database
 */
export const getDatabaseMetadata = (variables: GetDatabaseMetadataVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.DatabaseMetadata,
    GetDatabaseMetadataError,
    undefined,
    {},
    {},
    GetDatabaseMetadataPathParams
  >({ url: '/workspaces/{workspaceId}/dbs/{dbName}', method: 'get', ...variables, signal });

export type UpdateDatabaseMetadataPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * The Database Name
   */
  dbName: Schemas.DBName;
};

export type UpdateDatabaseMetadataError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type UpdateDatabaseMetadataRequestBody = {
  ui?: {
    /**
     * @minLength 1
     */
    color?: string;
  };
  /**
   * The dedicated cluster where branches from this database will be created. Defaults to 'shared-cluster'.
   *
   * @minLength 1
   * @x-internal true
   */
  defaultClusterID?: string;
};

export type UpdateDatabaseMetadataVariables = {
  body?: UpdateDatabaseMetadataRequestBody;
  pathParams: UpdateDatabaseMetadataPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Update the color of the selected database
 */
export const updateDatabaseMetadata = (variables: UpdateDatabaseMetadataVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.DatabaseMetadata,
    UpdateDatabaseMetadataError,
    UpdateDatabaseMetadataRequestBody,
    {},
    {},
    UpdateDatabaseMetadataPathParams
  >({ url: '/workspaces/{workspaceId}/dbs/{dbName}', method: 'patch', ...variables, signal });

export type RenameDatabasePathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * The Database Name
   */
  dbName: Schemas.DBName;
};

export type RenameDatabaseError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 422;
      payload: Responses.SimpleError;
    }
  | {
      status: 423;
      payload: Responses.SimpleError;
    }
>;

export type RenameDatabaseRequestBody = {
  /**
   * @minLength 1
   */
  newName: string;
};

export type RenameDatabaseVariables = {
  body: RenameDatabaseRequestBody;
  pathParams: RenameDatabasePathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Change the name of an existing database
 */
export const renameDatabase = (variables: RenameDatabaseVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.DatabaseMetadata,
    RenameDatabaseError,
    RenameDatabaseRequestBody,
    {},
    {},
    RenameDatabasePathParams
  >({ url: '/workspaces/{workspaceId}/dbs/{dbName}/rename', method: 'post', ...variables, signal });

export type GetDatabaseGithubSettingsPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * The Database Name
   */
  dbName: Schemas.DBName;
};

export type GetDatabaseGithubSettingsError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type GetDatabaseGithubSettingsVariables = {
  pathParams: GetDatabaseGithubSettingsPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Retrieve current Github database settings
 */
export const getDatabaseGithubSettings = (variables: GetDatabaseGithubSettingsVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.DatabaseGithubSettings,
    GetDatabaseGithubSettingsError,
    undefined,
    {},
    {},
    GetDatabaseGithubSettingsPathParams
  >({ url: '/workspaces/{workspaceId}/dbs/{dbName}/github', method: 'get', ...variables, signal });

export type UpdateDatabaseGithubSettingsPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * The Database Name
   */
  dbName: Schemas.DBName;
};

export type UpdateDatabaseGithubSettingsError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 422;
      payload: Responses.SimpleError;
    }
  | {
      status: 423;
      payload: Responses.SimpleError;
    }
>;

export type UpdateDatabaseGithubSettingsVariables = {
  body: Schemas.DatabaseGithubSettings;
  pathParams: UpdateDatabaseGithubSettingsPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Map the database to a Github repository, Xata will create database branch previews for all new branches/PRs in the repo.
 */
export const updateDatabaseGithubSettings = (variables: UpdateDatabaseGithubSettingsVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    Schemas.DatabaseGithubSettings,
    UpdateDatabaseGithubSettingsError,
    Schemas.DatabaseGithubSettings,
    {},
    {},
    UpdateDatabaseGithubSettingsPathParams
  >({ url: '/workspaces/{workspaceId}/dbs/{dbName}/github', method: 'put', ...variables, signal });

export type DeleteDatabaseGithubSettingsPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
  /**
   * The Database Name
   */
  dbName: Schemas.DBName;
};

export type DeleteDatabaseGithubSettingsError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
  | {
      status: 404;
      payload: Responses.SimpleError;
    }
>;

export type DeleteDatabaseGithubSettingsVariables = {
  pathParams: DeleteDatabaseGithubSettingsPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * Delete any existing database Github settings
 */
export const deleteDatabaseGithubSettings = (variables: DeleteDatabaseGithubSettingsVariables, signal?: AbortSignal) =>
  controlPlaneFetch<
    undefined,
    DeleteDatabaseGithubSettingsError,
    undefined,
    {},
    {},
    DeleteDatabaseGithubSettingsPathParams
  >({ url: '/workspaces/{workspaceId}/dbs/{dbName}/github', method: 'delete', ...variables, signal });

export type ListRegionsPathParams = {
  /**
   * Workspace ID
   */
  workspaceId: Schemas.WorkspaceID;
};

export type ListRegionsError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Responses.BadRequestError;
    }
  | {
      status: 401;
      payload: Responses.AuthError;
    }
>;

export type ListRegionsVariables = {
  pathParams: ListRegionsPathParams;
} & ControlPlaneFetcherExtraProps;

/**
 * List regions available to create a database on
 */
export const listRegions = (variables: ListRegionsVariables, signal?: AbortSignal) =>
  controlPlaneFetch<Schemas.ListRegionsResponse, ListRegionsError, undefined, {}, {}, ListRegionsPathParams>({
    url: '/workspaces/{workspaceId}/regions',
    method: 'get',
    ...variables,
    signal
  });

export const operationsByTag = {
  oAuth: {
    getAuthorizationCode,
    grantAuthorizationCode,
    getUserOAuthClients,
    deleteUserOAuthClient,
    getUserOAuthAccessTokens,
    deleteOAuthAccessToken,
    updateOAuthAccessToken
  },
  users: { getUser, updateUser, deleteUser },
  authentication: { getUserAPIKeys, createUserAPIKey, deleteUserAPIKey },
  workspaces: {
    getWorkspacesList,
    createWorkspace,
    getWorkspace,
    updateWorkspace,
    deleteWorkspace,
    getWorkspaceMembersList,
    updateWorkspaceMemberRole,
    removeWorkspaceMember
  },
  invites: {
    inviteWorkspaceMember,
    updateWorkspaceMemberInvite,
    cancelWorkspaceMemberInvite,
    acceptWorkspaceMemberInvite,
    resendWorkspaceMemberInvite
  },
  xbcontrolOther: { listClusters, createCluster, getCluster, updateCluster },
  databases: {
    getDatabaseList,
    createDatabase,
    deleteDatabase,
    getDatabaseMetadata,
    updateDatabaseMetadata,
    renameDatabase,
    getDatabaseGithubSettings,
    updateDatabaseGithubSettings,
    deleteDatabaseGithubSettings,
    listRegions
  }
};
